<template>
    <div class="home_top">
        <div class="home_top_left"></div>
        <div class="home_top_right">
            <div class="bottom-nav">
                <div :class="item.isShow ? 'pageTopHide':'pageTopShow'" v-for="(item, index) in listArray" :key="index" @click="cutChange(item,index)">
                    <div class="text">{{item.name}}</div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                listArray:[
                    {
                        name:'首页',
                        isShow:true,
                        router:'/index'
                    },
                    {
                        name:'关于我们',
                        isShow:false,
                        router:'/about'
                    },
                    {
                        name:'平台介绍',
                        isShow:false,
                        router:'/introduce'
                    },
                    {
                        name:'',
                        isShow:false,
                        router:'/newStatus'
                    }
                ]
            }
        },
        watch:{
            $route(newData,oldDasta){
                this.getRoute()
          }
        },
        created(){
            this.getRoute()
        },
        mounted(){
            let lis = document.querySelectorAll('li');
            let underline = document.querySelector('.line');
            for (let index = 0; index < lis.length; index++) {
                lis[index].onclick = function () {
                    for (let i = 0; i < lis.length; i++) {
                        lis[i].classList.remove('current');
                    }
                    this.classList.add('current');
                    //还要偏移的量temp
                    let temp = (this.offsetWidth - underline.offsetWidth) / 2
                    underline.style.left = temp + this.offsetLeft + 'px';
                }
            }
        },
        methods:{
            getRoute(){
                if(this.$route && this.$route.path){
                    for(let i in this.listArray){
                        if(this.$route.path.indexOf(this.listArray[i].router ) != -1 ){
                            this.listArray[i].isShow = true
                        }else{
                            this.listArray[i].isShow = false
                        }
                        /* if (this.listArray[i].router == this.$route.path)){
                           this.listArray[i].isShow = true
                       }else{
                           this.listArray[i].isShow = false
                       }*/
                    }
                }

            },
            cutChange(item,index){
                for (let item in this.listArray) {
                    this.listArray[item].isShow = false
                }
                this.listArray[index].isShow = true;
                this.$router.push({
                    path:item.router
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    .home_top{
        width: 100%;
        height: 52px;
        display: flex;
        align-items: center;
        position: sticky;
        top: 0;
        z-index: 9999;
        background: #ffffff;
        .home_top_left{
            width: 155px;
            height: 34px;
            background: url("./img/logo_small.png") no-repeat;
            background-size: 155px 34px;
            margin: auto 0px auto 202px;
        }
        .home_top_right{
            flex: 1;
            padding-left: 82px;
            height: 100%;
            .bottom-nav{
                height: 100%;
                display: flex;
                justify-content:flex-start;
                align-items: center;
                /*>div{
                    height: 100%;
                    width: 56px;
                    margin-right: 25px;
                    display: flex;
                    flex-direction: column;
                    cursor:pointer;
                }
                ul,li{
                    list-style: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .pageNav{
                    height: 100%;
                    .current{
                        color: red;
                    }
                    .line{
                        width: 56px;
                        height: 4px;
                        background: #3E83FE;
                        border-radius: 25px;
                        position: absolute;
                        bottom: 0;
                    }
                    a{
                        height: 100%;
                        display: block;
                        position: relative;
                        padding-left: 20px;
                        padding-right: 20px;
                        color: #000000;
                        font-size: 13px;
                        line-height: 62px;
                        text-align: center;
                        text-decoration: none;
                    }
                    a::after{
                        !*content: "";*!
                        height: 4px;
                        line-height: 50px;
                        text-align: center;
                        overflow: hidden;
                        display: block;
                        left: 25%;
                        bottom: 0;
                        position: absolute;
                        width: 55%;
                        background: #3E83FE;
                        !*transform: scaleX(0);*!
                        !*transition:  0.1s;*!
                        border-radius: 20px;
                    }
                    !*a:hover::after {transform: scaleX(1);}*!
                }*/
                >div {
                    height: 100%;
                    width: 56px;
                    margin-right: 25px;
                    display: flex;
                    flex-direction: column;
                    cursor:pointer;
                    .text{
                        height: 12px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000;
                        line-height: 52px;
                        text-align: center;
                    }
                }
                .pageTopHide{
                    height: 100%;
                    width: 56px;
                    margin-right: 25px;
                    display: flex;
                    flex-direction: column;
                    cursor:pointer;
                    .text{
                        height: 12px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #3E83FE;
                        line-height: 52px;
                        text-align: center;
                    }
                    .line{
                        width: 56px;
                        height: 4px;
                        background: #3E83FE;
                        border-radius: 25px;
                        position: absolute;
                        bottom: 0;
                    }
                }
                .pageTopShow{
                    height: 100%;
                    width: 56px;
                    margin-right: 25px;
                    display: flex;
                    flex-direction: column;
                    cursor:pointer;
                    .text{
                        height: 12px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000;
                        line-height: 52px;
                        text-align: center;
                    }
                }
                /*>div:hover{
                    height: 100%;
                    width: 56px;
                    margin-right: 25px;
                    display: flex;
                    flex-direction: column;
                    cursor:pointer;
                    .text{
                        height: 12px;
                        font-size: 12px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        !*color: #3E83FE;*!
                        line-height: 62px;
                        text-align: center;
                    }
                    .line{
                        !*width: 56px;*!
                        !*height: 4px;*!
                        !*background: #3E83FE;*!
                        !*border-radius: 25px;*!
                        !*position: absolute;*!
                        !*bottom: 0;*!
                    }
                }*/
            }
        }
    }
</style>
